<template>
  <div>
    <div class="div">
      <div class="WordSection1" style="layout-grid: 18pt">
        <h2 style="margin-bottom: 22.5pt">
          <span lang="ZH-TW" style="font-size: 12pt; font-family: 'Microsoft JhengHei', sans-serif">
            臺北市公有路外停車場【車輛申請無卡進出停車場及停車費繳納服務】約定條款
          </span>
        </h2>

        <h2 style="margin-bottom: 22.5pt">
          <span lang="ZH-TW" style="font-size: 12pt; font-family: 'Microsoft JhengHei', sans-serif">
            悠遊付依據本條款提供服務，為保障申請者權益，請您務必詳讀本條款。當您以會員帳號使用悠遊付
            申請本服務時，即表示您已閱讀、瞭解並同意接受本條款。
          </span>
        </h2>

        <p class="MsoNormal" style="margin-left: 36pt; text-indent: 0cm">
          <span style="font-family: 'Microsoft JhengHei', sans-serif">
            1.
            <span style="font: 7pt 'Times New Roman'"></span>
          </span>
          <span lang="ZH-TW" style="font-family: 'Microsoft JhengHei', sans-serif">
            車輛申請無卡進出停車場及停車費繳納服務，是指您將一組車牌號碼同時間與一個支付業者代繳服務綁定，並登錄於臺北市政府智慧支付平台
          </span>
          <span style="font-family: 'Microsoft JhengHei', sans-serif">
            (
            <span lang="ZH-TW">下稱智慧支付平台</span>
            )
            <span lang="ZH-TW">，視為您授權臺北市政府依法令規定蒐集、處理、利用及傳遞您的個人資料</span>
            (
            <span lang="ZH-TW">身分證字號、電子郵件信箱、手機號碼</span>
            )
            <span lang="ZH-TW">。您亦可透過設定隨時取消綁定車號。</span>
          </span>
        </p>

        <p class="MsoNormal" style="margin-left: 36pt; text-indent: 0cm">
          <span style="font-family: 'Microsoft JhengHei', sans-serif">
            2.
            <span style="font: 7pt 'Times New Roman'"></span>
          </span>
          <span lang="ZH-TW" style="font-family: 'Microsoft JhengHei', sans-serif">
            服務生效期間，申請之車號可在臺北市公有路外停車場享有無卡進出服務，停車場計算產生之停車費用，將透過綁定之支付工具提供您即時扣繳服務。
          </span>
        </p>

        <p class="MsoNormal" style="margin-left: 36pt; text-indent: 0cm">
          <span style="font-family: 'Microsoft JhengHei', sans-serif">
            3.
            <span style="font: 7pt 'Times New Roman'"></span>
          </span>
          <span lang="ZH-TW" style="font-family: 'Microsoft JhengHei', sans-serif">
            申請車號綁定或解除綁定成功，隔日起本服務於公有停車場生效或停止。
          </span>
        </p>

        <p class="MsoNormal" style="margin-left: 36pt; text-indent: 0cm">
          <span style="font-family: 'Microsoft JhengHei', sans-serif">
            4.
            <span style="font: 7pt 'Times New Roman'"></span>
          </span>
          <span lang="ZH-TW" style="font-family: 'Microsoft JhengHei', sans-serif">申請停止本服務</span>
          <span style="font-family: 'Microsoft JhengHei', sans-serif">
            (
            <span lang="ZH-TW">取消車號綁定</span>
            )
            <span lang="ZH-TW">，解除綁定生效前所產生之停車費用仍依申請人設定自動扣繳，解除綁定生效後產生之停車費用，則依道路交通管理處罰條理第</span>
            56
            <span lang="ZH-TW">條第</span>
            3
            <span lang="ZH-TW">項規定，逕行通知催繳。</span>
          </span>
        </p>

        <p class="MsoNormal" style="margin-left: 36pt; text-indent: 0cm">
          <span style="font-family: 'Microsoft JhengHei', sans-serif">
            5.
            <span style="font: 7pt 'Times New Roman'"></span>
          </span>
          <span lang="ZH-TW" style="font-family: 'Microsoft JhengHei', sans-serif">申請者應如期繳納路外停車</span>
          <span style="font-family: 'Microsoft JhengHei', sans-serif">
            (
            <span lang="ZH-TW">場</span>
            )
            <span lang="ZH-TW">停車費，扣款失敗或逾期未繳納停車費，臺北市政府得停止提供本服務。</span>
          </span>
        </p>

        <p class="MsoNormal">
          <span style="font-family: 'Microsoft JhengHei', sans-serif">
            <br />
            <br />
          </span>
        </p>

        <p class="indent">
          <b><span lang="ZH-TW" style="font-family: 'Microsoft JhengHei', sans-serif">停車費繳納與付款失敗之處理</span></b>
        </p>

        <p class="MsoNormal" style="margin-left: 36pt; text-indent: 0cm">
          <span style="font-family: 'Microsoft JhengHei', sans-serif">
            1.
            <span style="font: 7pt 'Times New Roman'"></span>
          </span>
          <span lang="ZH-TW" style="font-family: 'Microsoft JhengHei', sans-serif">
            倘有重複繳款情事，您了解此項重複繳款的申請作業需依照臺北市停車管理工程處重覆繳費規定辦理退款。
          </span>
        </p>

        <p class="MsoNormal" style="margin-left: 36pt; text-indent: 0cm">
          <span style="font-family: 'Microsoft JhengHei', sans-serif">
            2.
            <span style="font: 7pt 'Times New Roman'"></span>
          </span>
          <span lang="ZH-TW" style="font-family: 'Microsoft JhengHei', sans-serif">
            因故發生支付錯誤或付款失敗情況，車輛無法進出臺北市公有路外停車場，請使用停車場現場繳費服務或洽詢停車場服務窗口。
          </span>
        </p>

        <p class="MsoNormal" style="margin-left: 36pt; text-indent: 0cm">
          <span style="font-family: 'Microsoft JhengHei', sans-serif">
            3.
            <span style="font: 7pt 'Times New Roman'"></span>
          </span>
          <span lang="ZH-TW" style="font-family: 'Microsoft JhengHei', sans-serif">
            申請者接獲扣繳失敗通知，自接獲通之次日起可使用路邊臨時停車費查繳服務補繳費用。
          </span>
        </p>

        <p class="indent">
          <span lang="ZH-TW" style="font-family: 'Microsoft JhengHei', sans-serif">
            臺北市政府將保留得以隨時增刪修改本條款之權利，任何增刪修飾後之內容，應以本府公告時間為即時生效日，如您繼續使用本
          </span>
          <span style="font-family: 'Microsoft JhengHei', sans-serif">
            APP
            <span lang="ZH-TW">，視同您同意本條款之全部修改。本條款最近一次更新時間為：中華民國</span>
            107
            <span lang="ZH-TW">年</span>
            9
            <span lang="ZH-TW">月</span>
            21
            <span lang="ZH-TW">日。</span>
          </span>
        </p>

        <p class="MsoNormal"><span style="font-family: 'Microsoft JhengHei', sans-serif">&nbsp;</span></p>
      </div>
    </div>
    <div style="margin: 16pt 24pt">
      <button class="btn btn-primary" @click="addCarNumberToCardlessBinding">我已詳閱並同意以上條款</button>
    </div>
  </div>
</template>

<script>
import { cardlessBinding } from '../../api/api';

export default {
  name: 'terms-of-policy',
  data() {
    return {
      carNumber: this.$route.query.car_number,
      carType: this.$route.query.car_type,
    };
  },
  methods: {
    addCarNumberToCardlessBinding() {
      var form = { car_number: this.carNumber, car_type: this.carType };
      cardlessBinding(form).then((res) => {
        if (res.error == null) {
          alert('\n' + '約定成功！\n' + '將於隔日生效，約定扣款生效後，才可開始以車牌辨識進出公有停車場，並以悠遊付進行扣款繳費。');
        } else {
          if (res.error.sub_code === '80905') {
            alert('車輛已綁訂悠遊付');
          } else if (res.error.sub_code === '80906') {
            alert('車輛已綁訂其他支付業者');
          } else {
            alert(res.error.message);
          }
        }
        this.$router.go(-2);
      });
    },
  },
};
</script>

<style scoped>
.div {
  background: rgba(64, 64, 64, 0.05);
  padding: 16pt;
  margin: 16pt 24pt 0 24pt;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFangTC-Medium;
  height: calc(92vh - 100pt);
  overflow: auto;
  webkit-overflow-scrolling: touch;
}
</style>
